import { COLLECTIONS } from '../../constants/collections';
import { createDocument, getDocument, getAllDocuments, updateDocument, deleteDocument } from './firestoreService';

const getCollectionPath = (tenantId) => `tenants/${tenantId}/${COLLECTIONS.DRIVERS}`;

// Create driver
export const createDriver = async (driverData, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required for creating driver');

    const data = {
        ...driverData,
        tenantId,
        isActive: true,
        createdAt: new Date()
    };

    return await createDocument(getCollectionPath(tenantId), data);
};

// Update driver
export const updateDriver = async (driverId, driverData, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required for updating driver');
    return await updateDocument(getCollectionPath(tenantId), driverId, driverData);
};

// Get driver by ID
export const getDriver = async (driverId, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    return await getDocument(getCollectionPath(tenantId), driverId);
};

// Get all drivers for a transporter
export const getTransporterDrivers = async (transporterId, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');

    const conditions = [];
    if (transporterId) {
        conditions.push({ type: 'where', field: 'transporterId', operator: '==', value: transporterId });
    }

    const results = await getAllDocuments(getCollectionPath(tenantId), conditions);
    return results.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
};

// Delete driver
export const deleteDriver = async (driverId, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    return await deleteDocument(getCollectionPath(tenantId), driverId);
};
